import { useRegistration } from "./RegistrationContext";

const SIZES = {
  sm: "px-4 py-2 text-[12px] sm:text-[13px] sm:px-5",
  md: "px-7 py-3.5 text-sm",
  lg: "px-8 py-4 text-[15px] sm:text-base sm:px-12 sm:py-5",
};

export const GoldButton = ({ children, size = "md", pulse = false, href, className = "", ...rest }) => {
  const cls = `btn-gold ${pulse ? "btn-pulse" : ""} ${SIZES[size]} ${className}`;
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={cls} {...rest}>
        <span>{children}</span>
      </a>
    );
  }
  return (
    <button type="button" className={cls} {...rest}>
      <span>{children}</span>
    </button>
  );
};

export const OutlineGoldButton = ({ as: Tag = "a", children, className = "", ...rest }) => (
  <Tag className={`inline-flex items-center justify-center rounded-full border border-[rgba(232,184,74,0.6)] px-5 py-3 text-center text-[14px] font-semibold tracking-[0.02em] text-[var(--gold)] transition-[background-color,transform] duration-200 hover:-translate-y-px hover:bg-[rgba(232,184,74,0.1)] ${className}`} {...rest}>
    {children}
  </Tag>
);

export const PulseCTA = ({ children = "SAVE MY FREE SEAT →", size = "lg", className = "", ...rest }) => {
  const { open } = useRegistration();
  return (
    <GoldButton size={size} pulse onClick={open} className={className} {...rest}>
      {children}
    </GoldButton>
  );
};
